import React from "react";
import ReactDOM from "react-dom";
import { LicenseManager } from "ag-grid-enterprise";

import Bootstrap from "./Bootstrap";

LicenseManager.setLicenseKey(process.env.AG_GRID_LICENSE_KEY);

// ONLY IN DEVELOPMENT MODE (since in dev mode lies the webpack code on that host:port)
if (process.env.NODE_ENV === "development") {
  // @ts-ignore
  __webpack_public_path__ = "http://localhost:8080/";
}

ReactDOM.render(
  <React.StrictMode>
    <Bootstrap />
  </React.StrictMode>,
  document.getElementById("root"),
);
